<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.64 7C10.7747 7.00051 10.9079 7.02824 11.0316 7.08151C11.1554 7.13478 11.2671 7.2125 11.36 7.31L15.22 11.31C15.4032 11.4969 15.5059 11.7482 15.5059 12.01C15.5059 12.2718 15.4032 12.5231 15.22 12.71L11.22 16.71C11.1268 16.8032 11.0161 16.8772 10.8943 16.9277C10.7724 16.9781 10.6419 17.0041 10.51 17.0041C10.3781 17.0041 10.2476 16.9781 10.1258 16.9277C10.0039 16.8772 9.89324 16.8032 9.8 16.71C9.70676 16.6168 9.6328 16.5061 9.58234 16.3842C9.53188 16.2624 9.50591 16.1319 9.50591 16C9.50591 15.8681 9.53188 15.7376 9.58234 15.6157C9.6328 15.4939 9.70676 15.3832 9.8 15.29L13.1 12L9.92 8.7C9.73375 8.51264 9.62921 8.25919 9.62921 7.995C9.62921 7.73081 9.73375 7.47736 9.92 7.29C10.0146 7.19611 10.1271 7.12209 10.2507 7.07229C10.3744 7.02249 10.5067 6.99791 10.64 7Z"
      fill="black"
    />
  </svg>
</template>
<script>
export default {
  name: "ForwardArrowIcon",
};
</script>
